<template>
  <div class="title-bar">
    <div class="flex-y-conter">
      <slot name="icon">
        <img v-if="icon" :src="icon" class="title-icon" />
      </slot>
      <span class="title-txt">{{ title }}</span>
    </div>
    <div>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TitleBar",
    props: {
      icon: [Object, String],
      title: { type: String, default: "" },
    },
  };
</script>

<style scoped lang="less">
  .flex-y-conter {
    display: flex;
    align-items: center;
  }
  .title-bar {
    box-sizing: border-box;
    width: 100%;
    height: 35px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 5px;
    border-bottom: 1px solid #00b2ff;

    .title-icon {
      width: 33px;
      height: 33px;
      margin-right: 3px;
    }

    .title-txt {
      font-size: 20px;
      line-height: 26px;
      font-weight: 400;
      color: #ffffff;
      text-shadow: 0px 0px 7px #0084ff;
    }
  }
</style>
